import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { hasPermission } from "../permissions/hasPermission";

const PrivateRoute = ({ children, resource, ...rest }) => {
    const { user } = useContext(AuthContext);
    if (!user) return <Route {...rest}><Redirect to="/login" /></Route>;
    if (resource && !hasPermission(user, resource, 'view')) return <Redirect to="/reservations" />
    return <Route {...rest}>{children}</Route>;
};

export default PrivateRoute;
